import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Steps,
  Tooltip
} from 'antd'
import QuestHeader from './components/QuestHeader.jsx'
import history from '../../history.js'
import {
  AllowAccess,
  ImageSelect,
  TopicsInput
} from '../../components/Form/index.js'
import FileUploadComponent from '../DiscussionRoom/DiscussionCreateMain/components/UploadFiles/UploadFiles'
import _ from 'lodash'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import actions from '../../store/actions/index.js'
import './quest.scss'
import Badge from '../Courses/Create/nestedComponents/CourseCreateMain/components/Badge'
import Certificate from '../Courses/Create/nestedComponents/CourseCreateMain/components/Certificate'
import StoryModal from './components/StoryModal.jsx'
import LocationPickerModal from './components/LocationPickerModal.jsx'

const { Step } = Steps
const { Option } = Select

const activityOptions = [
  { label: 'AR Scan', value: 'ar_scan' },
  { label: 'AR Geo Location', value: 'ar_location' },
  { label: 'Quiz', value: 'quiz' },
  { label: 'Open Ended', value: 'open_ended' },
  { label: 'All the above', value: 'all' }
]
const QuestCreateUpdate = ({ form, upload }) => {
  const {
    getFieldDecorator,
    validateFields,
    getFieldsValue,
    getFieldValue,
    setFieldsValue
  } = form

  const { t } = useTranslation()
  const [activityModalVisible, setActivityModalVisible] = useState(false)
  const [storyModalVisible, setStoryModalVisible] = useState(false)
  const [activeIndex, setActiveIndex] = useState(null)
  const [certModal, setCertModal] = useState({
    isCertificateLoading: false,
    open: false
  })
  const [locationModal, setLocationModal] = useState({
    isLoading: false,
    open: false
  })
  const [badgeModal, setBadgeModal] = useState({
    isBadgeLoading: false,
    open: false
  })
  const [isFetching, setIsFetching] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [isUploadingFile, setIsUploadingFile] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [current, setCurrent] = useState(0)
  const [generatedContent, setGeneratedContent] = useState([
    {
      id: 0,
      title: '🏫 START – Professor Pine’s Lab',
      location: 'NIS Science Lab or Library',
      coordinates: { lat: 18.846878, lng: 98.99085 },
      why:
        'Provides a controlled environment to introduce the quest and distribute AR tools.',
      source: 'nis.ac.thchiangmailocator.com',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 1,
      title: '🌈 Stop 1 – Rainbow Grove',
      location: 'NIS School Garden or Nearby Community Garden',
      coordinates: { lat: 18.8475, lng: 98.9912 },
      why: 'Access to various plants and flowers to represent colorful fruits.',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 2,
      title: '🏞️ Stop 2 – Crunchy Canyon',
      location: 'NIS Playground or Nearby Park',
      coordinates: { lat: 18.8478, lng: 98.9905 },
      why:
        'Open space suitable for physical activities and games related to fiber-rich foods.',
      source: 'international-schools-database.com',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 3,
      title: '🦴 Stop 3 – Calcium Cavern',
      location: 'NIS Cafeteria or Home Economics Room',
      coordinates: { lat: 18.8469, lng: 98.9907 },
      why:
        'Ideal for discussions and activities centered around calcium-rich foods.',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 4,
      title: '🍭 Stop 4 – The Sweet Trap',
      location: 'Local Convenience Store (e.g., 7-Eleven)',
      coordinates: { lat: 18.8472, lng: 98.9918 },
      why:
        'Real-world setting to teach about sugar content in snacks and drinks.',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 5,
      title: '🐷 Stop 5 – Iron Island',
      location: 'NIS Cooking Class or Science Lab',
      coordinates: { lat: 18.8468, lng: 98.9906 },
      why:
        'Hands-on activities to learn about iron-rich foods and their benefits.',
      source: 'international-schools-database.com',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 6,
      title: '🧾 Stop 6 – Label Labyrinth',
      location: 'Local Supermarket (e.g., Rimping Supermarket)',
      coordinates: { lat: 18.848, lng: 98.992 },
      why: 'Practical experience in reading and understanding food labels.',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 7,
      title: '💧 Stop 7 – Hydration Falls',
      location: 'NIS Sports Field or Nearby Water Fountain',
      coordinates: { lat: 18.8476, lng: 98.9909 },
      why:
        'Emphasizes the importance of hydration, especially during physical activities.',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 8,
      title: '🌉 Stop 8 – Allergy Bridge',
      location: 'NIS Health Room or Classroom',
      coordinates: { lat: 18.8467, lng: 98.9904 },
      why:
        'Controlled environment to discuss food allergies and safe eating practices.',
      source: 'chiangmailocator.com',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 9,
      title: '🌋 Stop 9 – Veggie Volcano',
      location: "NIS Garden or Local Farmer's Market",
      coordinates: { lat: 18.8473, lng: 98.9915 },
      why:
        'Exposure to a variety of vegetables to promote healthy eating habits.',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    },
    {
      id: 10,
      title: '🏛️ FINAL Stop – Golden Apple Temple',
      location: 'NIS Auditorium or Assembly Hall',
      coordinates: { lat: 18.846878, lng: 98.99085 },
      why:
        'Suitable for the culmination of the quest, awarding certificates, and celebrating achievements.',
      source: 'chiangmailocator.com',
      arImage:
        'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg'
    }
  ])

  const [steps] = useState([
    { title: 'Basic Info', value: 0 },
    { title: 'Quest Parameters', value: 1 },
    { title: 'Quest Content', value: 2 }
  ])
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    passMark: 70,
    allowOthersToEdit: false,
    topics: '',
    location: {
      city: '',
      country: '',
      full: '',
      lat: null,
      lng: null,
      town: ''
    },
    coverImage: null,
    attachedPdf: null,
    objectives: '',
    badgeId: '',
    certId: '',
    description: '',
    ageGroup: 'elementary',
    stepsCount: 3,
    pointsPerStep: 10,
    activityTypes: [],
    storyMood: {
      complexity: '',
      genre: '',
      narrativeHook: '',
      narrativeStructure: '',
      narrativeStyle: '',
      storyLength: '',
      storyPlot: '',
      timePeriod: '',
      tone: '',
      vocabulary: ''
    },
    storyComplexity: 'medium',
    useOrgRepo: true,
    useInternet: false,
    uploadedFiles: []
  })
  const [selectedCover, setSelectedCover] = useState({
    id: '',
    link: '',
    file_size: '',
    filename: ''
  })
  const [attachedData, setAttachedData] = useState({
    filenames: [],
    attachmentIds: []
  })
  const [attachedFiles, setAttachedFiles] = useState({
    filenames: [],
    attachmentIds: []
  })
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const stepParam = searchParams.get('step')

    if (stepParam && !isNaN(stepParam)) {
      setCurrent(Number(stepParam - 1))
    }
  }, [])
  useEffect(() => {
    history.push(
      `quest-create?step=${current === 0 ? 1 : current === 1 ? 2 : 3}`
    )
    setFieldsValue(formData)
  }, [current])

  const togglePanel = index => {
    setActiveIndex(prev => (prev === index ? null : index))
  }
  const handleNext = () => {
    setCurrent(current + 1)
    // if (current === 0) {
    //   validateFields(['title', 'cover_id', 'pass_score'], (err, values) => {
    //     if (!err) {
    //       setFormData(prev => ({ ...prev, ...values }))
    //       const nextStep = current + 1
    //       setCurrent(nextStep)
    //     }
    //   })
    // } else if (current === 1) {
    //   validateFields(
    //     ['objectives', 'ageGroup', 'steps', 'activityType'],
    //     (err, values) => {
    //       if (!err) {
    //         setFormData(prev => ({ ...prev, ...values }))
    //         const nextStep = current + 1
    //         setCurrent(nextStep)
    //       }
    //     }
    //   )
    // }
  }
  const handleBack = () => {
    setCurrent(current - 1)
  }
  const handleFinish = () => {
    message.success('Quest Saved')
  }
  const onTopicsChange = arr => {
    console.log(
      'test',
      arr.map(item => item.id)
    )
  }
  console.log('test', formData)
  const onAllowAccessEmailsChange = v => {
    console.log('test', v)
  }
  const handleCheckboxChange = (name, checked) => {
    setFormData({
      ...formData,
      [name]: checked
    })
  }
  const handleSelectChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    })
  }
  const handleNumberChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    })
  }

  // Load dummy generated content when moving to step 3
  const generateDummyContent = () => {
    const content = []
    for (let i = 1; i <= formData.stepsCount; i++) {
      content.push({
        stepNumber: i,
        story: `This is the story for step ${i}. The treasure hunters have discovered a clue leading them to an ancient artifact hidden in the nearby forest.`,
        question: `What do you think is hidden in the mysterious box mentioned in the story?`,
        image:
          'https://www.phoslab.com/wp-content/uploads/2018/07/iStock-866470840-water-sample-testing-300x200.jpg',
        points: formData.pointsPerStep
      })
    }
    // setGeneratedContent(content)
    setCurrent(current + 1)
  }
  const handlePointsChange = (index, value) => {
    const updatedContent = [...generatedContent]
    updatedContent[index].points = value
    // setGeneratedContent(updatedContent)
  }

  const allOptions = ['ar_scan', 'ar_location', 'quiz', 'open_ended']
  const handleChangeActivity = (value, close = false) => {
    console.log('test', value)
    let newValue
    if (value.includes('all')) {
      newValue = allOptions
    } else {
      newValue = value.filter(v => v !== 'all')
    }

    form.setFieldsValue({
      activityTypes: newValue
    })

    setFormData({
      ...formData,
      activityTypes: newValue
    })
    close && setActivityModalVisible(false)
  }

  const badgePresentationUpload = (body, imageType) => {
    const isCertificate = imageType === 'Certificate'

    const toggleLoading = loading => {
      if (isCertificate) {
        setCertModal({ open: false, isCertificateLoading: loading })
      } else {
        setBadgeModal({ open: false, isBadgeLoading: loading })
      }
    }
    const updateFormDataWithId = id => {
      setFormData({
        ...formData,
        ...(isCertificate ? { certId: id } : { badgeId: id })
      })
    }

    toggleLoading(true)
    upload(body)
      .then(res => {
        toggleLoading(false)
        updateFormDataWithId(res.id)
      })
      .catch(() => {
        toggleLoading(false)
        message.error(t('v4:error_occured_try_again'))
      })
  }
  const setStoryMode = newValue => {
    setFormData({
      ...formData,
      storyMood: newValue
    })
    setStoryModalVisible(false)
  }
  return (
    <Spin spinning={isFetching}>
      <section className="section" style={{ paddingBottom: '10rem' }}>
        <QuestHeader t={t} />
        <Row gutter={[16, 16]} justify="center" type="flex">
          <Col xs={24} sm={24} md={20} lg={18} xl={16}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 20
              }}
            >
              <Steps current={current} style={{ marginBottom: 24 }}>
                {steps.map(item => (
                  <Step key={item.value} title={item.title} />
                ))}
              </Steps>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24}>
            <div className="form-body">
              {current === 0 && (
                <Form layout="vertical">
                  <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <Form.Item
                        label="Title of the Quest"
                        colon={false}
                        required={false}
                      >
                        {getFieldDecorator('title', {
                          initialValue: formData.title,
                          rules: [
                            {
                              required: true,
                              message: 'Please input Quest Title!'
                            }
                          ]
                        })(<Input placeholder="Quest Title" />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <Form.Item
                        label={t('labels:organiser')}
                        colon={false}
                        required={false}
                      >
                        {getFieldDecorator('organiser', {
                          initialValue: formData.author
                        })(
                          <Input
                            addonBefore={t('general:by')}
                            size="large"
                            tighter="true"
                            placeholder={t('placeholders:organiser')}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <TopicsInput
                        defaultTopics={formData.topics}
                        onTopicsChange={onTopicsChange}
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <AllowAccess
                        form={form}
                        onChange={onAllowAccessEmailsChange}
                        defaultHostEmails={formData.host_emails}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <Form.Item
                        label={t('v4:pass_score')}
                        colon={false}
                        required={false}
                      >
                        {getFieldDecorator('pass_score', {
                          initialValue: formData.passScore,
                          rules: [
                            {
                              required: true,
                              message: 'Please input Pass Score!'
                            },
                            {
                              type: 'number',
                              asyncValidator: (rule, value) => {
                                return new Promise((resolve, reject) => {
                                  if (
                                    (value > 0 && value <= 100) ||
                                    value === undefined ||
                                    value === null
                                  ) {
                                    resolve()
                                  } else {
                                    reject(t('v4:pass_score_mark'))
                                  }
                                })
                              }
                            }
                          ]
                        })(
                          <InputNumber
                            size="large"
                            tighter="true"
                            style={{ width: '100%', borderRadius: 4 }}
                            placeholder="Minimum Score"
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <Form.Item
                        label={'Quest Location'}
                        colon={false}
                        required={false}
                      >
                        <Button
                          className={`item ${
                            formData.location && formData.location.lat
                              ? 'icon-check'
                              : ''
                          }`}
                          shape="round"
                          icon={
                            formData.location && formData.location.lat
                              ? 'check'
                              : 'plus'
                          }
                          onClick={() => {
                            setLocationModal({ ...locationModal, open: true })
                          }}
                        >
                          {formData.location && formData.location.lat
                            ? 'Location Added'
                            : 'Select Location'}
                        </Button>

                        <LocationPickerModal
                          value={formData.location}
                          open={locationModal.open}
                          onClose={() =>
                            setLocationModal({ open: false, location: null })
                          }
                          onLocationSelect={coords =>
                            setFormData({ ...formData, location: coords })
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <Button
                        className={`item ${
                          formData.certId ? 'icon-check' : ''
                        }`}
                        shape="round"
                        icon={formData.certId ? 'check' : 'plus'}
                        onClick={() => {
                          setCertModal({ ...certModal, open: true })
                        }}
                        loading={certModal.isCertificateLoading}
                      >
                        {formData.certId
                          ? t('v4:certificate_added')
                          : t('v4:create_certificate')}
                      </Button>
                      &nbsp;
                      <Button
                        className={`item ${
                          formData.badgeId ? 'icon-check' : ''
                        }`}
                        icon={formData.badgeId ? 'check' : 'plus'}
                        onClick={() => {
                          setBadgeModal({ ...certModal, open: true })
                        }}
                        shape="round"
                        loading={badgeModal.isBadgeLoading}
                      >
                        {formData.badgeId
                          ? t('v4:badge_added')
                          : t('v4:create_badge')}
                      </Button>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        required={false}
                        colon={false}
                        className="no_bottom_margin"
                      >
                        {getFieldDecorator('cover_id', {
                          initialValue: selectedCover.id,
                          rules: [
                            {
                              required: true,
                              message: 'Please upload cover image!'
                            }
                          ]
                        })(
                          <ImageSelect
                            form={form}
                            label={'Cover Picture'}
                            coverInput={selectedCover.id ? selectedCover : null}
                            onCoverChange={data => {
                              setSelectedCover(data)
                              setFieldsValue({ cover_id: data.id })
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        label={
                          <div
                            style={{ display: 'flex', textTransform: 'none' }}
                          >
                            Attach Files (pdf)
                            <div
                              style={{
                                marginLeft: 10,
                                background: 'red',
                                color: '#fff',
                                borderRadius: '50%',
                                display: 'flex',
                                justifyContent: 'center',
                                height: 20,
                                width: 20
                              }}
                            >
                              {attachedData.filenames.length}
                            </div>
                          </div>
                        }
                        colon={false}
                        required={false}
                        className="no_bottom_margin"
                      >
                        {getFieldDecorator('files', {
                          initialValue: attachedData.filenames || undefined
                        })(
                          <FileUploadComponent
                            styleHeight={250}
                            setIsLoading={setIsUploading}
                            ids={attachedData.attachmentIds}
                            data={attachedData}
                            setData={setAttachedData}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                      <Form.Item
                        label="Description"
                        name="description"
                        rules={[{ required: false }]}
                      >
                        <Input.TextArea rows={4} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              )}
              {current === 1 && (
                <Form layout="vertical">
                  <Row gutter={[16, 16]} justify="center">
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Name of the Quest" name="title">
                        <Input disabled value={formData.title} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        label="Age Group"
                        name="ageGroup"
                        rules={[{ required: true }]}
                      >
                        <Select size="large">
                          <Option value="preschool">Preschool (3-5)</Option>
                          <Option value="elementary">Elementary (6-10)</Option>
                          <Option value="middle">Middle School (11-13)</Option>
                          <Option value="high">High School (14-18)</Option>
                          <Option value="adult">Adult</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                      <Form.Item
                        label="Objectives"
                        name="objectives"
                        rules={[{ required: true }]}
                      >
                        <Input.TextArea rows={4} />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        label="Number of steps"
                        name="stepsCount"
                        rules={[{ required: true }]}
                      >
                        <InputNumber
                          size="large"
                          tighter="true"
                          style={{ width: '100%', borderRadius: 4 }}
                          onChange={value =>
                            handleNumberChange('stepsCount', value)
                          }
                          min={1}
                          step={1}
                          max={25}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item label="Points per step" name="pointsPerStep">
                        <InputNumber
                          min={1}
                          size="large"
                          tighter="true"
                          style={{ width: '100%', borderRadius: 4 }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        label="Content Sources"
                        style={{ marginBottom: 20 }}
                      >
                        <Checkbox
                          checked={formData.useOrgRepo}
                          onChange={e =>
                            handleCheckboxChange('useOrgRepo', e.target.checked)
                          }
                          style={{ display: 'block', marginBottom: 8 }}
                        >
                          <Icon type="database" /> Include organization
                          repository
                        </Checkbox>
                        <br />
                        <Checkbox
                          checked={formData.useInternet}
                          onChange={e =>
                            handleCheckboxChange(
                              'useInternet',
                              e.target.checked
                            )
                          }
                        >
                          <Icon type="global" /> Fetch content from the internet
                        </Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="activityTypes"
                        style={{ marginBottom: 10 }}
                        rules={[
                          {
                            required: true,
                            message: 'Please select at least one activity type'
                          }
                        ]}
                      >
                        <Button
                          className={`item ${
                            formData.activityTypes.length > 0
                              ? 'icon-check'
                              : ''
                          }`}
                          shape="round"
                          icon={
                            formData.activityTypes.length ? 'check' : 'plus'
                          }
                          onClick={() => {
                            setActivityModalVisible(true)
                          }}
                        >
                          {formData.activityTypes.length > 0
                            ? `${
                                formData.activityTypes.length > 1
                                  ? 'Activities'
                                  : 'Activity'
                              }(${formData.activityTypes.length})`
                            : 'Select Activity Types'}
                        </Button>
                      </Form.Item>
                      <Form.Item
                        style={{ marginBottom: 10 }}
                        name="storyMode"
                        rules={[
                          {
                            required: true,
                            message: 'Please select at least one activity type'
                          }
                        ]}
                      >
                        <Button
                          className={`item ${
                            formData.storyMood.tone ? 'icon-check' : ''
                          }`}
                          shape="round"
                          icon={formData.storyMood.tone ? 'check' : 'plus'}
                          onClick={() => {
                            setStoryModalVisible(true)
                          }}
                        >
                          {formData.storyMood.tone
                            ? `Story Mode`
                            : 'Select Story Mode'}
                        </Button>
                      </Form.Item>
                      <Modal
                        title="Select Activity Types"
                        visible={activityModalVisible}
                        footer={[
                          <Button
                            key="ok"
                            type="primary"
                            onClick={() => {
                              handleChangeActivity(formData.activityTypes, true)
                            }}
                          >
                            Confirm
                          </Button>
                        ]}
                        // onCancel={() => {
                        //   setActivityModalVisible(false)
                        // }}
                        closable={false}
                        okText="Confirm"
                      >
                        <Checkbox.Group
                          value={formData.activityTypes}
                          onChange={handleChangeActivity}
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '8px',
                            alignItems: 'start'
                          }}
                        >
                          {activityOptions.map(option => (
                            <Checkbox
                              key={option.value}
                              value={option.value}
                              disabled={
                                activityOptions.length - 1 ===
                                  formData.activityTypes.length &&
                                option.value === 'all'
                              }
                              style={{ margin: 0, alignItems: 'center' }}
                            >
                              {option.label}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      </Modal>
                      <StoryModal
                        visible={storyModalVisible}
                        onCancel={() => {
                          setStoryModalVisible(false)
                        }}
                        setStoryMode={setStoryMode}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        style={{ marginBottom: 24 }}
                        label={
                          <div
                            style={{ display: 'flex', textTransform: 'none' }}
                          >
                            Upload Files (word files, pdf)
                            <div
                              style={{
                                marginLeft: 10,
                                background: 'red',
                                color: '#fff',
                                borderRadius: '50%',
                                display: 'flex',
                                justifyContent: 'center',
                                height: 20,
                                width: 20
                              }}
                            >
                              {attachedFiles.filenames.length}
                            </div>
                          </div>
                        }
                        colon={false}
                        required={false}
                        className="no_bottom_margin"
                      >
                        {getFieldDecorator('files', {
                          initialValue: attachedFiles.filenames || undefined
                          // rules: [
                          //   {
                          //     required: true,
                          //     message: 'Please add file(s)!'
                          //   }
                          // ]
                        })(
                          <FileUploadComponent
                            styleHeight={250}
                            setIsLoading={setIsUploadingFile}
                            ids={attachedFiles.attachmentIds}
                            data={attachedFiles}
                            setData={setAttachedFiles}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              )}
              {current === 2 && (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: 16
                    }}
                  >
                    <div className="quest-contain-title">Generated Quest</div>
                    <Button
                      type="primary"
                      icon="download"
                      onClick={() =>
                        message.success(
                          'Treasure hunt content downloaded as a slide deck!'
                        )
                      }
                    >
                      Download Slide Deck
                    </Button>
                  </div>
                  <div className="accordion">
                    {generatedContent.map((content, index) => (
                      <div className="accordion__item" key={index}>
                        <div
                          className={`accordion__header ${
                            activeIndex === index ? 'active' : ''
                          }`}
                          onClick={() => togglePanel(index)}
                        >
                          <div className="accordion__title">
                            {content.title}
                          </div>
                          <div className="accordion__meta">
                            {content.location && (
                              <>
                                <div className="accordion__location">
                                  {content.location}
                                </div>
                                <a
                                  className="accordion__map-link"
                                  href={`https://www.google.com/maps?q=${content.coordinates.lat},${content.coordinates.lng}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Lat: {content.coordinates.lat}, Lng:{' '}
                                  {content.coordinates.lng}
                                </a>
                              </>
                            )}
                          </div>
                        </div>

                        <div
                          className={`accordion__body ${
                            activeIndex === index ? 'open' : ''
                          }`}
                        >
                          <div className="accordion__content">
                            <div className="accordion__text">
                              <h4>Why this stop?</h4>
                              <p>{content.why}</p>

                              {content.source && (
                                <>
                                  <h4>Source</h4>
                                  <p>
                                    <a
                                      href={
                                        content.source.startsWith('http://') ||
                                        content.source.startsWith('https://')
                                          ? content.source
                                          : `https://${content.source}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="accordion__source-link"
                                    >
                                      {content.source}
                                    </a>
                                  </p>
                                </>
                              )}
                            </div>

                            {content.arImage && (
                              <div className="accordion__image-wrapper">
                                <img
                                  src={content.arImage}
                                  alt={`AR for ${content.title}`}
                                  className="accordion__image"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </section>
      <div className="p-footer">
        <div className="p-footer__inner">
          {!isFetching && (
            <div className="p-footer__item">
              <Fragment>
                &nbsp;
                <span>
                  {current === 0 && (
                    <Button
                      type="primary"
                      className="rounded"
                      loading={isSaving}
                      onClick={handleNext}
                    >
                      Next Step
                      <Icon type="right" />
                    </Button>
                  )}
                  {current === 1 && (
                    <Fragment>
                      <Button
                        type="primary"
                        className="rounded"
                        loading={isSaving}
                        onClick={handleBack}
                        style={{ marginRight: 8 }}
                      >
                        <Icon type="left" />
                        Previous
                      </Button>
                      <Button
                        type="primary"
                        className="rounded"
                        loading={isSaving}
                        onClick={generateDummyContent}
                      >
                        Generate Content
                        <Icon type="right" />
                      </Button>
                    </Fragment>
                  )}
                  {current === 2 && (
                    <Fragment>
                      <Button
                        type="primary"
                        className="rounded"
                        loading={isSaving}
                        onClick={handleBack}
                        style={{ marginRight: 8 }}
                      >
                        <Icon type="left" />
                        Edit Parameters
                      </Button>
                      <Button
                        type="primary"
                        className="rounded"
                        loading={isSaving}
                        onClick={handleFinish}
                      >
                        Save Quest
                      </Button>
                    </Fragment>
                  )}
                </span>
              </Fragment>
            </div>
          )}
        </div>
      </div>
      <Modal
        style={{ top: 1 }}
        bodyStyle={{ height: 'auto' }}
        visible={badgeModal.open}
        onCancel={() => {
          setBadgeModal({ ...badgeModal, open: false })
        }}
        footer={null}
        width="1229px"
        centered
      >
        <Badge onUploadImage={body => badgePresentationUpload(body, 'Badge')} />
      </Modal>
      <Modal
        style={{ top: 1 }}
        bodyStyle={{ height: 'auto' }}
        visible={certModal.open}
        onCancel={() => {
          setCertModal({ ...certModal, open: false })
        }}
        footer={null}
        width="1229px"
        centered
      >
        <Certificate
          type={'Course'}
          onUploadImage={body => badgePresentationUpload(body, 'Certificate')}
        />
      </Modal>
    </Spin>
  )
}
const mapStateToProps = state => ({
  organizations: state.organizations.list,
  user: state.user
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      upload: (file, opts) => dispatch(actions.library.upload(file, opts)),
      updateTopicList: actions.topics.updateTopicList
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'quest_form' })(QuestCreateUpdate))
